export default __webpack_public_path__ + "06b59e0c9415d23a5493a409d45137bf.jpg";